import {Injectable} from '@angular/core';
declare let ga: Function;

@Injectable()
export class GoogleAnalyticsService {

    public emitEvent(eventCategory: string,
                     eventAction: string,
                     eventLabel: string = null) {
        ga('send', 'event', {
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: eventLabel
        });
    }

    public emitPageView(page: string) {
        ga('set', 'page', page);
        ga('send', 'pageview');
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/google-analytics-service.ts